import React from 'react';
import {Button} from "@mui/material";
import {FormattedMessage} from "react-intl";
import DoneIcon from '@mui/icons-material/Done';

type RejectButtonProps = {
    onClick: () => void;
    color?: string;
};

const RejectButton: React.FC<RejectButtonProps> = (props) => {

    const handleClick = (e: React.MouseEvent<HTMLAnchorElement> | React.MouseEvent<HTMLButtonElement>) => {
        e.stopPropagation();
        props.onClick();
    }

    return (
        <Button
            variant="outlined"
            size="small"
            // @ts-ignore
            color={props.color || "error"}
            startIcon={<DoneIcon/>}
            onClick={(e) => handleClick(e)}>
            <FormattedMessage id={'COMMON_REJECT'}/>
        </Button>
    );
};
export default RejectButton;
